import React from 'react';
import { Card, CardContent, Grid, Typography, Box } from '@mui/material';

/**
 * TemplateInfoCard Component
 *
 * Displays basic template information.
 *
 * @param {Object} props
 * @param {Object} props.data - Template analytics data
 */
function TemplateInfoCard({ data }) {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography variant="caption" color="text.secondary">
              Template ID
            </Typography>
            <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
              {data.template_id}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Box display="flex" flexDirection="column" alignItems="flex-start">
              <Typography variant="caption" color="text.secondary">
                Category
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mt: 0.5,
                  whiteSpace: 'nowrap',
                  overflow: 'visible',
                  textOverflow: 'clip',
                }}
              >
                {data.template_category?.replace('PromptCategory.', '') ||
                  'N/A'}
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography variant="caption" color="text.secondary">
              Template Name
            </Typography>
            <Typography variant="body2" noWrap>
              {data.template_name || 'N/A'}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography variant="caption" color="text.secondary">
              Total Versions
            </Typography>
            <Typography variant="body2">
              {data.version_analytics?.length || 0}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default TemplateInfoCard;
